
	let forms = document.getElementsByClassName('metal-price-calculator-block');

	for (const form of forms) {

		const slider = document.getElementById('valueSlider');
		const display = document.getElementById('valueDisplay');
		const radioButtons = document.querySelectorAll('input[name="metal[]"]');

		function calculateAndDisplay() {
			const sliderValue = parseInt(slider.value);
			const selectedRadio = document.querySelector('input[name="metal[]"]:checked');

			if (selectedRadio) {
				const metalValue = selectedRadio.value;
				const result = parseInt(Math.round(metalValue * sliderValue));
				let chars = result.toString().length;
				const formatted = new Intl.NumberFormat('sv-SE').format(result);

				display.innerHTML = `<div class="result chars-${chars}">${formatted} kr</div><div class="calculation"><span class="value">${metalValue} kr</span> × <span class="wight">${sliderValue} g</span></div>`;
			} else {
				display.textContent = '0';
			}
		}

		// Update display when slider changes
		slider.addEventListener('input', calculateAndDisplay);
		slider.addEventListener('change', calculateAndDisplay);

		// Update display when radio button selection changes
		radioButtons.forEach(radio => {
			radio.addEventListener('change', calculateAndDisplay);
		});

		// Initial calculation
		calculateAndDisplay();

	}

	const slider = document.getElementById('valueSlider');
	const sliderColor = getComputedStyle(slider).getPropertyValue('--slider-color').trim();
	const trackColor = getComputedStyle(slider).getPropertyValue('--track-color').trim();

	function updateSliderBackground() {
		const percentage = ((slider.value - (slider.min)) / (slider.max - slider.min)) * 100;
		const padding = 25 - (25 * percentage/100) + 'px';
		slider.style.background = `linear-gradient(to right, ${sliderColor} 0%, ${sliderColor} calc(${percentage}% + ${padding}), ${trackColor} calc(${percentage}% + ${padding}), ${trackColor} 100%)`;
	}

	// Update on input
	slider.addEventListener('input', updateSliderBackground);

	// Initialize
	updateSliderBackground();


